import * as Svc from './svc'
import * as util from '@/utils'

export const getProducts = (ctx, { page, type, content }) => {
  return Svc.getProducts(page, type, content)
}

export const getProduct = (ctx, { id }) => {
  return Svc.getProduct(id)
}

export const getOrders = (ctx, { page, content, bdate, edate }) => {
  return Svc.getOrders(page, content, null, bdate, edate)
}

export const getOrderDetail = (ctx, { id, page, content }) => {
  return Svc.getOrderDetail(id, page, content)
}

export const getUsers = (ctx, { page, content }) => {
  return Svc.getUsers(page, content)
}

export const getUser = (ctx, { id }) => {
  return Svc.getUser(id)
}

export const resetPwd = (ctx, { id }) => {
  return Svc.resetPwd(id)
}

export const deleteAccount = (ctx, { id }) => {
  return Svc.deleteAccount(id)
}

export const accountTypes = ctx => {
  return Svc.accountType()
}

export const login = ({ commit }, { username, password }) => {
  return Svc.login(username, util.encrypt(password)).then(resp => {
    util.setStorage('pvsuser', { name: resp.username })
    commit('setName', resp.username)
    commit('setUserinfo', resp)
  })
}

export const clearCookies = () => {
  util.removeStorage('pvsuser')
  return Svc.logout()
}

export const getPlans = (ctx, { page }) => {
  return Svc.plans(page)
}

export const initInfo = ({ commit }) => {
  return Svc.getInfo().then(resp => {
    util.setStorage('pvsuser', { name: resp.username })
    commit('setName', resp.username)
    commit('setUserinfo', resp)
  })
}

export const addUser = (ctx, {params,account_id}) => {
  return Svc.addUser(params,account_id)
}

export const addSubsidiary = (ctx, {name, code, description, vechain_url}) => {
  return Svc.addSubsidiary(name, code, description, vechain_url)
}

export const addChannel = (ctx, {name, code, description}) => {
  return Svc.addChannel(name, code, description)
}

export const changePwd = (ctx, {oldPwd, newPwd,code}) => {
  return Svc.changePwd(oldPwd, newPwd,code)
}

export const getStores = (ctx, {page}) => {
  return Svc.getStores(page)
}

export const getStore = (ctx, {id}) => {
  return Svc.getStore(id)
}

export const updateStore = (ctx,{params,store_id}) => {
  return Svc.updateStore(params,store_id)
}

export const getChannel = (ctx, {page}) => {
  return Svc.getChannel(page)
}

export const getSubsidiary = (ctx, {page}) => {
  return Svc.getSubsidiary(page)
}

export const getSubsidiaryInfo = (ctx, {code}) => {
  return Svc.getSubsidiaryInfo(code)
}

export const getDBTodayDatas = ctx => {
  return Svc.getDBTodayAllDatas()
}

export const getDBHistoryDatasSVC = ({ commit }) => {
  return Svc.getDBHistoryDatas().then((responses) => {
    commit('setDBHistoryDatas', responses)
  })
}

export const getAdmins = (ctx, {page}) => {
  return Svc.getAdmins(page)
}

export const getAdmin = (ctx, {id}) => {
  return Svc.getAdmin(id)
}

export const getManagedAdminTypes = (ctx) => {
  return Svc.getManagedAdminTypes()
}

export const getManagedSubsidiaryScope = (ctx) => {
  return Svc.getManagedSubsidiaryScope()
}


export const getManagedChannelScope = (ctx) => {
  return Svc.getManagedChannelScope()
}

export const addAdmin = (ctx,{params,admin_id}) => {
  return Svc.addAdmin(params,admin_id)
}

export const resetAdminPwd = (ctx, { id }) => {
  return Svc.resetAdminPwd(id)
}

export const cancelOrder = (ctx, { order_num }) => {
  return Svc.cancelOrder(order_num)
}

export const sendSms = (ctx) => {
  return Svc.sendSms()
}

export const records = (ctx,{order_num,vechain_id}) => {
  return Svc.records(order_num,vechain_id)
}

export const getLogs = (ctx,  { page, content, bdate, edate,type }) => {
  return Svc.getLogs(page, content, null, bdate, edate,type)
}


export const getLogsType = (ctx) => {
  return Svc.logsType()
}

export const getVechainProductList = (ctx) => {
  return Svc.getVechainProductList()
}

export const getVechainProductList2 = (ctx) => {
  return Svc.getVechainProductList2()
}

export const getVechainOrders = (ctx, {page}) => {
  return Svc.getVechainOrders(page);
}

export const createVechainOrder = (ctx, {params}) => {
  return Svc.createVechainOrder(params);
}

export const createVechainOrder2 = (ctx, {params}) => {
  return Svc.createVechainOrder2(params);
}

export const confirmVechainOrder = (ctx, {requestNo}) => {
  return Svc.confirmVechainOrder(requestNo);
}

export const confirmVechainOrder2 = (ctx, {requestNo}) => {
  return Svc.confirmVechainOrder2(requestNo);
}

export const importVechainOrderTags = (ctx, {requestNo}) => {
  return Svc.importVechainOrderTags(requestNo);
}

export const getLatestVechainOrderAddress = (ctx) => {
  return Svc.getLatestVechainOrderAddress();
}

export const getVechainOrderDetail = (ctx, {requestNo}) => {
  return Svc.getVechainOrderDetail(requestNo);
}

export const getVechainOrderDetail2 = (ctx, {requestNo}) => {
  return Svc.getVechainOrderDetail2(requestNo);
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js